export interface SelectableRowProps {
  isSelected: boolean;
}

export enum ResultNavigationOptions {
  NOT_NAVIGATING,
  NAVIGATE_SAME_TAB,
  NAVIGATE_NEW_TAB,
}
